import request from '@/utils/request';

// 工单质检分析列表
export function worksnAnalysisListApi(params) {
  return request({
    url: '/admin/worksn_analysis',
    method: 'get',
    params: params,
  });
}
// 工单质检分析详情
export function worksnAnalysisDetailApi() {
  return request({
    url: `/admin/worksn_analysis/${id}`,
    method: 'get',
  });
}
// 工单质检分析编辑
export function worksnAnalysisEditApi(data) {
  return request({
    url: `/admin/save_worksn_analysis/${data.id}`,
    method: 'put',
    data: data,
  });
}
// 工单质检分析置顶
export function worksnAnalysisTopApi(id) {
  return request({
    url: `/admin/top_worksn_analysis/${id}`,
    method: 'put',
  });
}
// 工单质检分析标记
export function worksnAnalysisTagApi(id) {
  return request({
    url: `/admin/tag_worksn_analysis/${id}`,
    method: 'put',
  });
}
// 工单客服列表
export function getUserListApi() {
  return request({
    url: '/admin/admin_user_list',
    method: 'get',
  });
}
// VIP质检分析列表
export function vipAnalysisListApi(params) {
  return request({
    url: '/admin/vip_analysis',
    method: 'get',
    params: params,
  });
}
// VIP质检分析详情
export function vipAnalysisDetailApi(id) {
  return request({
    url: `/admin/vip_analysis/${id}`,
    method: 'get',
  });
}
// VIP质检分析编辑
export function vipAnalysisEditApi(data) {
  return request({
    url: `/admin/save_vip_analysis/${data.id}`,
    method: 'put',
    data: data,
  });
}
// VIP质检分析置顶
export function vipAnalysisTopApi(id) {
  return request({
    url: `/admin/top_vip_analysis/${id}`,
    method: 'put',
  });
}
// VIP质检分析标记
export function vipAnalysisTagApi(id) {
  return request({
    url: `/admin/tag_vip_analysis/${id}`,
    method: 'put',
  });
}
// VIP客服列表
export function getVipListApi() {
  return request({
    url: '/admin/admin_user_vip_list',
    method: 'get',
  });
}
// 普客质检分析列表
export function normalAnalysisListApi(params) {
  return request({
    url: '/admin/normal_analysis',
    method: 'get',
    params: params,
  });
}
// 普客质检分析添加
export function normalAnalysisAddApi(data) {
  return request({
    url: '/admin/add_normal_analysis',
    method: 'post',
    data: data,
  });
}
// 普客质检分析编辑
export function normalAnalysisEditApi(data) {
  return request({
    url: `/admin/save_normal_analysis/${data.id}`,
    method: 'put',
    data: data,
  });
}
// 普客质检分析置顶
export function normalAnalysisTopApi(id) {
  return request({
    url: `/admin/top_normal_analysis/${id}`,
    method: 'put',
  });
}
// 普客质检分析标记
export function normalAnalysisTagApi(id) {
  return request({
    url: `/admin/tag_normal_analysis/${id}`,
    method: 'put',
  });
}
// 普客质检分析详情
export function normalAnalysisDetailApi() {
  return request({
    url: `/admin/normal_analysis/${id}`,
    method: 'get',
  });
}
// 普客质检分析删除
export function normalAnalysisDeleteApi(id) {
  return request({
    url: `/admin/delete_normal_analysis/${id}`,
    method: 'delete',
  });
}
// 普客质检分析上传
export function normalAnalysisUploadApi(data) {
  return request({
    url: '/admin/upload_normal_analysis',
    method: 'post',
    data: data,
  });
}
// 微信质检列表
export function wechatAnalysisListApi(params) {
  return request({
    url: '/admin/wechat_analysis',
    method: 'get',
    params: params,
  });
}
// 微信质检添加
export function wechatAnalysisAddApi(data) {
  return request({
    url: '/admin/add_wechat_analysis',
    method: 'post',
    data: data,
  });
}
// 微信质检编辑
export function wechatAnalysisEditApi(data) {
  return request({
    url: `/admin/save_wechat_analysis/${data.id}`,
    method: 'put',
    data: data,
  });
}
// 微信质检置顶
export function wechatAnalysisTopApi(id) {
  return request({
    url: `/admin/top_wechat_analysis/${id}`,
    method: 'put',
  });
}
// 微信质检标记
export function wechatAnalysisTagApi(id) {
  return request({
    url: `/admin/tag_wechat_analysis/${id}`,
    method: 'put',
  });
}
// 微信质检详情
export function wechatAnalysisDetailApi() {
  return request({
    url: `/admin/wechat_analysis/${id}`,
    method: 'get',
  });
}
// 微信质检删除
export function wechatAnalysisDeleteApi(id) {
  return request({
    url: `/admin/delete_wechat_analysis/${id}`,
    method: 'delete',
  });
}
// 微信质检上传
export function wechatAnalysisUploadApi(data) {
  return request({
    url: '/admin/upload_wechat_analysis',
    method: 'post',
    data: data,
  });
}
// 质检分析-申诉-微信
export function wechatAnalysisAppeal(data) {
  return request({
    url: '/admin/wechat_analysis_appeal/' + data.id,
    method: 'post',
    data: data,
  });
}
// 质检分析-审批-微信
export function wechatAnalysisAApproval(data) {
  return request({
    url: '/admin/wechat_analysis_approval/' + data.id,
    method: 'post',
    data: data,
  });
}
// 质检分析-点击确认-微信
export function wechatAnalysisEnsure(data) {
  return request({
    url: '/admin/wechat_analysis_ensure/',
    method: 'put',
    data: data,
  });
}
// 质检分析-查看审批说明
export function wechatAnalysisApproval(params) {
  return request({
    url: `/admin/wechat_analysis_approval/${params.id}`,
    method: 'get',
    params: params,
  });
}
// 质检分析-查看二次申诉列表
export function wechatAnalysisAppealGet(params) {
  return request({
    url: `/admin/wechat_analysis_appeal/${params.id}`,
    method: 'get',
    params: params,
  });
}

// 质检分析-申诉-工单
export function worksnAnalysisAppealPost(data) {
  return request({
    url: '/admin/worksn_analysis_appeal/' + data.id,
    method: 'post',
    data: data,
  });
}
// 质检分析-审批-工单
export function worksnAnalysisAApproval(data) {
  return request({
    url: '/admin/worksn_analysis_approval/' + data.id,
    method: 'post',
    data: data,
  });
}
// 质检分析-点击确认-工单
export function worksnAnalysisEnsure(data) {
  return request({
    url: '/admin/worksn_analysis_ensure/',
    method: 'put',
    data: data,
  });
}
// 质检分析-查看审批说明
export function worksnAnalysisApproval(params) {
  return request({
    url: `/admin/worksn_analysis_approval/${params.id}`,
    method: 'get',
    params: params,
  });
}
// 质检分析-查看二次申诉列表
export function worksnAnalysisAppealGet(params) {
  return request({
    url: `/admin/worksn_analysis_appeal/${params.id}`,
    method: 'get',
    params: params,
  });
}

// 质检分析-申诉-vip
export function vipAnalysisAppealPost(data) {
  return request({
    url: '/admin/vip_analysis_appeal/' + data.id,
    method: 'post',
    data: data,
  });
}
// 质检分析-审批-vip
export function vipAnalysisAApproval(data) {
  return request({
    url: '/admin/vip_analysis_approval/' + data.id,
    method: 'post',
    data: data,
  });
}
// 质检分析-点击确认-vip
export function vipAnalysisEnsure(data) {
  return request({
    url: '/admin/vip_analysis_ensure/',
    method: 'put',
    data: data,
  });
}
// 质检分析-查看审批说明
export function vipAnalysisApproval(params) {
  return request({
    url: `/admin/vip_analysis_approval/${params.id}`,
    method: 'get',
    params: params,
  });
}
// 质检分析-查看二次申诉列表
export function vipAnalysisAppealGet(params) {
  return request({
    url: `/admin/vip_analysis_appeal/${params.id}`,
    method: 'get',
    params: params,
  });
}

// 质检分析-申诉-normal
export function normalAnalysisAppealPost(data) {
  return request({
    url: '/admin/normal_analysis_appeal/' + data.id,
    method: 'post',
    data: data,
  });
}
// 质检分析-审批-normal
export function normalAnalysisAApproval(data) {
  return request({
    url: '/admin/normal_analysis_approval/' + data.id,
    method: 'post',
    data: data,
  });
}
// 质检分析-点击确认-normal
export function normalAnalysisEnsure(data) {
  return request({
    url: '/admin/normal_analysis_ensure/',
    method: 'put',
    data: data,
  });
}
// 质检分析-查看审批说明
export function normalAnalysisApproval(params) {
  return request({
    url: `/admin/normal_analysis_approval/${params.id}`,
    method: 'get',
    params: params,
  });
}
// 质检分析-查看二次申诉列表
export function normalAnalysisAppealGet(params) {
  return request({
    url: `/admin/normal_analysis_appeal/${params.id}`,
    method: 'get',
    params: params,
  });
}
// 获取审批人列表
export function adminUserApprovalList() {
  return request({
    url: `/admin/admin_user_approval_list`,
    method: 'get',
  });
}
